import React from 'react';
import styled from 'styled-components';

const SectionTitle = styled.div`
margin-bottom: ${props => props.center ? "70px" : "0px"};
h3{
    font-family: 'Kalam', cursive;
    text-align:${props => props.center ? "center" : "start"};
    font-size: 40px;
    @media (max-width:593px){
            font-size: 31px;
         }

}
p{
    max-width: 552px;
    margin: 0 auto;
    text-align: center;
    font-size: 13px;
    color: #8c8c8c;
}
`;

export default function TitleSection(props) {
    return (
        <SectionTitle center={props.center}>
            <h3>{props.text}</h3>
            {props.title ? (
                <p>
                    Lorem ipsum dolor sit amet, conse ctetur
                    adi pisicin g elit. Doloribus repel lendus,
                    pariatur qui provident repel lendus!
                </p>
            ) : null}
        </SectionTitle>
    )
}
